import { stagedRevisionId } from '../fixture-ids';

export const stagedRevisionLegacyAlternates = {};

export const stagedRevisionLegacyFixtures = {
  PIPELINE_VARIABLE_UPDATED: {
    action: 'PIPELINE_VARIABLE_UPDATED',
    debugData: {
      id: stagedRevisionId,
      pipelineName: 'Web Analytics',
      pipelineVars: { retries: 3, batchSize: 500 },
      readyForDeploy: true,
    },
  },
};
